// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_lSWY5 {
  position : relative;
  width : 100%;
  height : 100%;
}
.toolbar_sEB5L {
  position : absolute;
  z-index : 1;
}

.topLeft_HPMG9 {
  top : var( --size-padMedium, 8px );
  left : var( --size-padMedium, 8px );
}

.bottomLeft_j7u6s {
  bottom : var( --size-padXLarge, 24px );
  left : var( --size-padMedium, 8px );
}

.topRight_wXtPK {
  top : var( --size-padMedium, 8px );
  right : var( --size-padMedium, 8px );
}

.bottomRight_WtKjv {
  bottom : var( --size-padXLarge, 24px );
  right : var( --size-padMedium, 8px );
}

.mapboxgl-ctrl-bottom-right {
  position: absolute;
  right: 50% !important;
  transform: translate(50%, 0);
  z-index: 0 !important;
}

.mapboxgl-ctrl-bottom-left {
  z-index: 0 !important;
}

.mapboxgl-ctrl-attrib-inner {
  font-size: 8px;
}

.mapContainer_zojzg {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/map/googleMap/GoogleMapViewer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".content {\n  position : relative;\n  width : 100%;\n  height : 100%;\n}\n.toolbar {\n  position : absolute;\n  z-index : 1;\n}\n\n.topLeft {\n  top : var( --size-padMedium, 8px );\n  left : var( --size-padMedium, 8px );\n}\n\n.bottomLeft {\n  bottom : var( --size-padXLarge, 24px );\n  left : var( --size-padMedium, 8px );\n}\n\n.topRight {\n  top : var( --size-padMedium, 8px );\n  right : var( --size-padMedium, 8px );\n}\n\n.bottomRight {\n  bottom : var( --size-padXLarge, 24px );\n  right : var( --size-padMedium, 8px );\n}\n\n:global(.mapboxgl-ctrl-bottom-right) {\n  position: absolute;\n  right: 50% !important;\n  transform: translate(50%, 0);\n  z-index: 0 !important;\n}\n\n:global(.mapboxgl-ctrl-bottom-left) {\n  z-index: 0 !important;\n}\n\n:global(.mapboxgl-ctrl-attrib-inner) {\n  font-size: 8px;\n}\n\n.mapContainer {\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_lSWY5`,
	"toolbar": `toolbar_sEB5L`,
	"topLeft": `topLeft_HPMG9`,
	"bottomLeft": `bottomLeft_j7u6s`,
	"topRight": `topRight_wXtPK`,
	"bottomRight": `bottomRight_WtKjv`,
	"mapContainer": `mapContainer_zojzg`
};
export default ___CSS_LOADER_EXPORT___;
